import { render, staticRenderFns } from "./m-goal-view-item.vue?vue&type=template&id=7d31a04f&"
import script from "./m-goal-view-item.vue?vue&type=script&setup=true&lang=js&"
export * from "./m-goal-view-item.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports